// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import BasicProfile from '../../components/Profile/ProfilePannel/BasicPannel';
import ReviewsRatings from '../../redux/containers/ReviewsRatingsContainer';
import UserTreksPannel from '../../components/Profile/TreksPannel/UserTreksPannel';
import BookingStatusList from './BookingStatusList';
import { fetchInvoices } from '../../redux/actions/authActions';
import ProfessionalProfile from '../../components/Profile/ProfilePannel/ProfessionalPannel';

const origin = 'profile';

const ratingsTitles = [
  'Communication',
  'Knowledge',
  'Organization Skills',
  'Fun Factor',
  'Safety',
];

type Props = {
  location: Object,
  userData: Object,
  urlUserId: string,
  loggedInUser: Object,
  match: { url: string },
  isViewingOwnProfile: boolean,
  updateUserData: (data: Object) => void,
  invoices: {
    completed: Array<Object>,
    pending: Array<Object>,
  },
  fetchInvoices: () => void,
};

class ProfileRoutes extends Component<Props> {
  componentDidMount() {
    const { isViewingOwnProfile, fetchInvoices } = this.props;

    if (isViewingOwnProfile) fetchInvoices();
  }

  render() {
    const prefix = this.props.match.url;
    const {
      invoices,
      userData,
      urlUserId,
      updateUserData,
      isViewingOwnProfile,
    } = this.props;

    return (
      <Fragment>
        <Route
          exact
          path={`${prefix}/(profile)?`}
          render={() => {
            return (
              <Fragment>
                <BasicProfile
                  isViewingOwnProfile={isViewingOwnProfile}
                  userData={userData}
                  urlUserId={urlUserId}
                  updateUserData={updateUserData}
                />
                {userData.is_leader && (
                  <Fragment>
                    <ProfessionalProfile
                      isViewingOwnProfile={isViewingOwnProfile}
                      userData={userData}
                      urlUserId={urlUserId}
                      updateUserData={updateUserData}
                    />
                    <hr />
                    <ReviewsRatings
                      origin={origin}
                      ratingsTitles={ratingsTitles}
                      allowReview={!isViewingOwnProfile}
                    />
                  </Fragment>
                )}
              </Fragment>
            );
          }}
        />

        <Switch>
          <Route path={`${prefix}/treks`} component={UserTreksPannel} />

          {/* <Route
            path={`${prefix}/cart`}
            render={() => <CartRoute urlUserId={urlUserId} />}
          /> */}

          {invoices && (
            <Fragment>
              <Route
                path={`${prefix}/purchase-list`}
                render={() => (
                  <BookingStatusList
                    title="PURCHASE LIST"
                    urlUserId={urlUserId}
                    data={invoices}
                  />
                )}
              />
            </Fragment>
          )}
        </Switch>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  invoices: user.invoices ? user.invoices : null,
});

export default connect(
  mapStateToProps,
  { fetchInvoices }
)(ProfileRoutes);



// WEBPACK FOOTER //
// ./src/screens/Profile/ProfileRoutes.jsx